export const about = {
  pageTitle: 'من نحن',
  pageSubtitle: 'أكثر من 15 عامًا من الخبرة في خدمة مشاريع التجديد والبناء الخاصة بك في بروكسل. شركة بلجيكية تضع الجودة ورضا العملاء في قلب أولوياتها',
  
  // Story Section
  storyTitle: 'قصتنا',
  storyP1: 'تأسست على يد <strong>Al Mohammad Abdul</strong>، ولدت Ktran من شغف بالبناء والتزام بالتميز. مع أكثر من 15 عامًا من الخبرة في قطاع التجديد، طورنا خبرة معترف بها في بروكسل ومحيطها',
  storyP2: 'يعتمد نهجنا على ثلاثة ركائز أساسية: الاستماع الدقيق لعملائنا، والجودة العالية لإنجازاتنا، والاحترام الصارم للمواعيد والميزانيات المتفق عليها',
  storyP3: 'كل مشروع فريد ويستحق اهتمامًا خاصًا. لهذا السبب نأخذ الوقت لتحليل احتياجاتك، ونقدم لك المشورة بشأن أفضل الحلول، ونرافقك من البداية إلى النهاية في مشروع التجديد الخاص بك',
  storyP4: 'مقرها في مولنبيك-سان-جان، شركتنا البلجيكية فخورة بالمساهمة في تحسين التراث العقاري في بروكسل، مشروعًا تلو الآخر',
  storyYears: 'سنة من الخبرة',
  
  // Values Section
  valuesTitle: 'قيمنا',
  valuesSubtitle: 'مبادئ توجه كل أعمالنا وتضمن رضاك',
  
  qualityTitle: 'جودة العمل',
  qualityDesc: 'نستخدم مواد عالية الجودة ونطبق أفضل التقنيات لضمان نتائج دائمة وجمالية',
  
  timeTitle: 'احترام المواعيد',
  timeDesc: 'كل مشروع مخطط بدقة. نلتزم باحترام المواعيد المتفق عليها لراحة بالك',
  
  cleanTitle: 'موقع عمل نظيف',
  cleanDesc: 'نحافظ على موقع عمل منظم ونظيف طوال فترة الأعمال، مع تنظيف كامل في نهاية كل يوم',
  
  communicationTitle: 'تواصل شفاف',
  communicationDesc: 'نبقيك على اطلاع في كل مرحلة من المشروع. نبقى متاحين للإجابة على أسئلتك والتعديل حسب احتياجاتك',
  
  // Timeline
  timelineTitle: 'مسيرتنا',
  timelineSubtitle: 'نمو مستمر قائم على الثقة والجودة',
  
  timeline2008Title: 'بداية المغامرة',
  timeline2008Desc: 'بدأ Al Mohammad Abdul نشاطه في البناء والتجديد في بروكسل',
  
  timeline2015Title: 'توسيع الخدمات',
  timeline2015Desc: 'توسيع الفريق وتنويع الخدمات لتلبية جميع احتياجات التجديد',
  
  timeline2020Title: 'شهادة الجودة',
  timeline2020Desc: 'الحصول على شهادات مهنية وتعزيز التزامنا بالتميز',
  
  timeline2024Title: 'أكثر من 150 مشروعًا',
  timeline2024Desc: 'اليوم، Ktran معترف بها كلاعب موثوق في التجديد في بروكسل ومحيطها',
  
  // Service Area
  serviceAreaTitle: 'منطقة التدخل',
  serviceAreaText: 'نتدخل بشكل رئيسي في <strong>بروكسل ومحيطها</strong>، مع معرفة عميقة بالخصوصيات المحلية والمعايير البلجيكية السارية',
  
  areaBrusselsTitle: 'بروكسل العاصمة',
  areaBrusselsDesc: 'جميع بلديات بروكسل',
  
  areaPeripheryTitle: 'ضواحي بروكسل',
  areaPeripheryDesc: 'برابانت الوالوني والفلمنكي',
  
  areaOnDemandTitle: 'تنقلات حسب الطلب',
  areaOnDemandDesc: 'اتصل بنا للمناطق الأخرى',
  
  // Contact Info
  contactInfoTitle: 'معلومات الاتصال',
  contactCompany: 'Ktran',
  contactVAT: 'رقم الضريبة: BE0729535515',
  contactAddress1: 'شارع روتردام 50',
  contactAddress2: '1080 مولنبيك-سان-جان',
  contactAddress3: 'بلجيكا',
  
  // CTA
  ctaTitle: 'لنعمل معًا على مشروعك',
  ctaText: 'اتصل بنا لمناقشة مشروع التجديد الخاص بك. سنكون سعداء بلقائك واقتراح حل مناسب لاحتياجاتك',
  ctaQuote: 'اطلب عرض سعر',
  ctaCall: 'اتصل بنا'
};